export const CLEAR_USER_INFO_DATA = 'CLEAR_USER_INFO_DATA';

export default function clearUserInfoData() {
  return {
    type: CLEAR_USER_INFO_DATA
  };
}
